import type { HtmlParserPlugin } from '~/plugins/dom-parser'

export * from './html/footnotes'

/**
 * A plugin for the HTML parser that removes all empty nodes from the given HTML document.
 * Empty nodes are defined as elements that contain no child elements or text content.
 *
 * @param doc - The HTML document to process and remove empty nodes from.
 * @returns The modified HTML document with all empty nodes removed.
 */
export const removeEmptyNodes: HtmlParserPlugin = (doc: Document) => {
  function removeEmpty(node: Node) {
    const children = Array.from(node.childNodes)

    for (const child of children) {
      if (child.nodeType === 1) {
        removeEmpty(child)
      }
    }

    if (
      node.nodeType === 1
      && !(node as Element).innerHTML.trim()
      && node.parentNode
    ) {
      node.parentNode.removeChild(node)
    }
  }

  removeEmpty(doc.body)

  return doc
}
